import React from "react";
import { Box, Chip, CircularProgress, Divider, Grid } from "@mui/material";
import { useSelector } from "../../../../store";
import { Base } from "../../../base";
import { useNavigate, useParams } from "react-router-dom";
import Moment from "react-moment";
import calculateTimeDifference from "../../../../helpers/calculateTimeDifference";
import { AnswerTypes } from "../../../../types/questionVM";
import KeyValue from "../../../../types/keyValue";
import moment from "moment";
import { ArrowBack, Room } from "@mui/icons-material";
import KeyName from "../../../../types/keyNameVM";
import theme from "../../../../theme";
import { AnswerSite } from "../../../../types/answerVM";
import JobViewAttachments from "./JobViewAttachments";
import Attachment from "../../../../types/attachment";

interface Props {
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  reopenJob: (id: number) => void;
  handleDownload: (id: number) => void;
  attachments: Attachment[];
}

const JobViewTop: React.FC<Props> = (props) => {
  const { setDeleteModal, reopenJob, handleDownload, attachments } = props;
  const navigate = useNavigate();
  const {
    job,
    status,
    // , jobChildren
  } = useSelector((store) => store.job);
  const { currentViewJobType } = useSelector((store) => store.jobType);
  const { status: attachmentTypeStatus } = useSelector(
    (store) => store.attachmentType,
  );
  const { simpleUserList } = useSelector((store) => store.user);
  const { id } = useParams();

  const jobHours = !!job.jobTimes.length
    ? job.jobTimes.map((jt) => jt.hours).reduce((a, b) => a + b)
    : 0;

  // const childHours = !!jobChildren.length
  //   ? jobChildren.map((jc) => jc.hours).reduce((a, b) => a + b)
  //   : 0;

  return (
    <>
      {status === "idle" &&
      job.id === +id! &&
      attachmentTypeStatus === "idle" ? (
        <>
          <Grid container size={12}>
            <Grid size={12} sx={{ color: theme.palette.error.main }}>
              {job.answers &&
                job.answers.some(
                  (a) => a.question?.answerType.id === AnswerTypes.Confidential,
                ) &&
                job.answers.find(
                  (a) => a.question?.answerType.id === AnswerTypes.Confidential,
                )?.value === true && (
                  <>
                    <Base.Text text="Confidential" variant="h3" />
                    <Divider
                      sx={{
                        borderColor: theme.palette.error.main,
                      }}
                    />
                  </>
                )}
            </Grid>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Grid
              container
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid>
                <Grid container alignItems={"center"}>
                  <Grid></Grid>
                  <Grid>
                    <Grid container alignItems={"center"} gap={1}>
                      <Base.IconButton
                        icon={<ArrowBack />}
                        label={`Return to ${currentViewJobType?.name}`}
                        onClick={() => {
                          if (currentViewJobType && currentViewJobType.id > 0) {
                            navigate(`/home/${currentViewJobType?.id}`);
                          } else {
                            navigate(-1);
                          }
                        }}
                      />
                      <Base.Text text={`${job.jobType?.name}: `} variant="h3" />
                      <Base.Text text={`${job.title}`} />
                    </Grid>
                    <Grid>
                      <Base.Text
                        text="Created on "
                        variant="body2"
                        component="span"
                      />
                      <Moment format="MM/DD/YY hh:mm A">{job.createdOn}</Moment>
                      {job.completedOn && (
                        <>
                          <Base.Text
                            text=" and completed on "
                            variant="body2"
                            component="span"
                          />
                          <Moment format="MM/DD/YY hh:mm A">
                            {job.closedDate ?? job.completedOn}
                          </Moment>
                        </>
                      )}
                      <Box sx={{ fontWeight: "bold" }} component={"span"}>
                        <Base.Text
                          text=". Total Time: "
                          component="span"
                          variant="body2"
                        />
                      </Box>
                      <Base.Text
                        text={`${calculateTimeDifference(
                          job?.createdOn!,
                          job.completedOn
                            ? job.closedDate
                              ? job.closedDate
                              : job.completedOn
                            : new Date(),
                        )}`}
                        component="span"
                      />
                    </Grid>
                    {!!job.modifiedById && !!job.modifiedOn && (
                      <Grid>
                        <Base.Text
                          text={`Last edited on ${moment(job.modifiedOn).format(
                            "MM/DD/YYYY hh:mmA",
                          )} by ${
                            simpleUserList.find(
                              (u) => u.id === job.modifiedById,
                            )?.value
                          }  `}
                          variant="body2"
                          component="span"
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid>
                <Grid container spacing={3}>
                  <Grid>
                    {!job.completedOn ? (
                      <Base.Button
                        text={"Edit"}
                        onClick={() => navigate(`/job/${job.id}`)}
                      />
                    ) : (
                      <Base.Button
                        text={"Reopen"}
                        onClick={() => reopenJob(job.id)}
                      />
                    )}
                  </Grid>
                  {!job.completedOn && (
                    <Grid>
                      <Base.Button
                        text={"Delete"}
                        onClick={() => setDeleteModal(true)}
                        type="delete"
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {job?.site && job?.site?.id > 0 && (
            <Grid size={{ md: 5, xs: 12 }}>
              <Grid container>
                <Grid size={{ xs: 12 }}>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text text="Site " component="span" variant="h4" />
                  </Box>
                  <Base.Text
                    text={`${job.site?.name}${
                      job.site.siteNumber ? `: ${job.site.siteNumber}` : ""
                    }`}
                    component="span"
                  />
                </Grid>
                <Grid size={{ xs: 12 }} pl="40px">
                  <Base.Text
                    text={`${job.site?.contactName}`}
                    component="span"
                  />
                </Grid>
                <Grid size={{ xs: 12 }} pl="40px">
                  <Base.Text
                    text={`${job.site?.contactPhone}`}
                    component="span"
                  />
                </Grid>
                <Grid size={{ xs: 12 }} pl="40px">
                  <Base.Text
                    text={`${job.site?.contactEmail}`}
                    component="span"
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid size={{ md: 5, xs: 12 }}>
            <Grid container direction={"column"}>
              <Grid>
                <Box sx={{ fontWeight: "bold" }} component={"span"}>
                  <Base.Text
                    text={`${
                      job.answers.find(
                        (a) => a.question?.answerType.id === AnswerTypes.Status,
                      )?.question?.questionText ?? "Status/Type"
                    } `}
                    component="span"
                    variant="h4"
                  />
                </Box>
                <Base.Text
                  text={`${
                    !!job.completedOn && !!job.jobType?.showRecentlyClosed
                      ? "Complete"
                      : job.answers?.length > 0
                      ? (
                          job.answers.find(
                            (a) =>
                              a.question?.answerType.id === AnswerTypes.Status,
                          )?.value as KeyValue
                        )?.value
                      : job.jobStatus?.name ?? ""
                  }`}
                  component="span"
                />
              </Grid>
              {job.jobCategory?.name && (
                <Grid>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text text="Category " component="span" variant="h4" />
                  </Box>
                  <Base.Text
                    text={`${job.jobCategory?.name}`}
                    component="span"
                  />
                </Grid>
              )}
              {job.jobSource?.value && (
                <Grid>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text text="Source " component="span" variant="h4" />
                  </Box>
                  <Base.Text
                    text={`${job.jobSource?.value}`}
                    component="span"
                  />
                </Grid>
              )}
              {job.communicationMethod && job.communicationMethod?.value && (
                <Grid>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text text="Method " component="span" variant="h4" />
                  </Box>
                  <Base.Text
                    text={`${job?.communicationMethod?.value}`}
                    component="span"
                  />
                </Grid>
              )}
              {job.owner && (
                <Grid>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text text="Owner " component="span" variant="h4" />
                  </Box>
                  <Base.Text text={`${job?.owner}`} component="span" />
                </Grid>
              )}
              {job.completedBy && (
                <Grid size={{ xs: 12 }}>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text
                      text="Completed By "
                      component="span"
                      variant="h4"
                    />
                  </Box>
                  <Base.Text
                    text={`${job?.completedBy.value}`}
                    component="span"
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          {job.parentJob?.value && (
            <Grid size={{ md: 5, xs: 12 }}>
              <Grid container>
                <Grid>
                  <Box sx={{ fontWeight: "bold" }} component={"span"}>
                    <Base.Text
                      text="Attached to Project: "
                      component="span"
                      variant="h4"
                    />
                  </Box>
                  <Box
                    onClick={() => {
                      navigate(`/job/view/${job.parentJob?.id}`);
                    }}
                    sx={{ cursor: "pointer", textDecoration: "underline" }}
                    component={"span"}
                  >
                    <Base.Text
                      text={`${job?.parentJob?.value}`}
                      component="span"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid size={{ xs: 12 }}>
            {currentViewJobType?.questions
              .filter(
                (a) =>
                  a.answerType.id !== AnswerTypes.Status &&
                  a.answerType.id !== AnswerTypes.Dates &&
                  a.answerType.id !== AnswerTypes.WeeklyTask &&
                  a.answerType.id !== AnswerTypes.Confidential &&
                  a.answerType.id !== AnswerTypes.Title,
              )
              .map((q) => {
                const answer = job.answers.find((a) => a.question?.id === q.id);
                return (
                  <Box key={answer?.id}>
                    {answer?.value !== "" &&
                      answer?.value !== "null" &&
                      !!answer?.value.toString().length &&
                      answer?.value.toString().trim() !== "," && (
                        <Grid container my={2} key={answer?.id}>
                          <Grid
                            size={{
                              xs:
                                answer?.question?.answerType.id ===
                                AnswerTypes.Multiline
                                  ? 12
                                  : 6,
                            }}
                          >
                            <Base.Text
                              text={answer?.question?.questionText ?? ""}
                              variant="h4"
                            />
                            {answer?.question?.answerType.id ===
                            AnswerTypes.Multiline ? (
                              (answer?.value as string)
                                .split("\n")
                                .map((t, key) => (
                                  <Box key={key}>
                                    <Base.Text text={t} />
                                  </Box>
                                ))
                            ) : answer?.question?.answerType.id ===
                                AnswerTypes.Category ||
                              answer?.question?.answerType.id ===
                                AnswerTypes.Source ||
                              answer?.question?.answerType.id ===
                                AnswerTypes.Method ? (
                              <Box>
                                <Base.Text
                                  text={`${(answer?.value as KeyName).name}`}
                                />
                              </Box>
                            ) : answer?.question?.answerType.id ===
                                AnswerTypes.MultipleChoice ||
                              answer?.question?.answerType.id ===
                                AnswerTypes.Site ||
                              answer?.question?.answerType.id ===
                                AnswerTypes.Job ? (
                              <Box>
                                {Array.isArray(answer?.value) ? (
                                  <Grid container spacing={1}>
                                    {(
                                      answer?.value as Array<
                                        KeyValue | string | AnswerSite
                                      >
                                    ).map(
                                      (ans: KeyValue | string | AnswerSite) => {
                                        return (
                                          <Grid
                                            key={
                                              typeof ans === "string"
                                                ? ans
                                                : ans.value
                                            }
                                          >
                                            <Chip
                                              label={
                                                typeof ans === "string"
                                                  ? ans
                                                  : ans.value
                                              }
                                              icon={
                                                !!(ans as AnswerSite)
                                                  .address ? (
                                                  <Room
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                      window.open(
                                                        `http://maps.google.com/?q=${
                                                          (ans as AnswerSite)
                                                            .address
                                                        }`,
                                                        "_blank",
                                                        "noopener,noreferrer",
                                                      );
                                                    }}
                                                  />
                                                ) : undefined
                                              }
                                            />
                                          </Grid>
                                        );
                                      },
                                    )}
                                  </Grid>
                                ) : (
                                  <Base.Text
                                    text={`${
                                      typeof answer?.value === "string"
                                        ? answer?.value
                                        : (answer?.value as KeyValue).value
                                    }`}
                                  />
                                )}
                              </Box>
                            ) : answer?.question?.answerType.id ===
                                AnswerTypes.Date ||
                              answer?.question?.answerType.id ===
                                AnswerTypes.Time ||
                              answer?.question?.answerType.id ===
                                AnswerTypes.DateTime ? (
                              <>
                                <Base.Text
                                  text={`${moment(answer?.value as Date).format(
                                    answer?.question?.answerType.id ===
                                      AnswerTypes.Date
                                      ? "MM/DD/YYYY"
                                      : answer?.question?.answerType.id ===
                                        AnswerTypes.Time
                                      ? "hh:mma"
                                      : "MM/DD/YYYY hh:mma",
                                  )}`}
                                />
                              </>
                            ) : answer?.question?.answerType.id ===
                              AnswerTypes.DateRange ? (
                              <Base.Text
                                text={
                                  answer?.value.toString().includes("null")
                                    ? "Incomplete Date"
                                    : `${
                                        (answer?.value as Date[])[0] !== null
                                          ? moment(
                                              (answer?.value as Date[])[0],
                                            ).format("MM/DD/YYYY")
                                          : "Incomplete Date"
                                      } - ${
                                        (answer?.value as Date[])[1] !== null
                                          ? moment(
                                              (answer?.value as Date[])[1],
                                            ).format("MM/DD/YYYY")
                                          : "Incomplete Date"
                                      }`
                                }
                              />
                            ) : answer?.question?.answerType.id ===
                              AnswerTypes.Checkbox ? (
                              <Base.Text
                                text={answer?.value === true ? "Yes" : "No"}
                              />
                            ) : (
                              <>
                                <Base.Text text={answer?.value as string} />
                              </>
                            )}
                          </Grid>
                        </Grid>
                      )}
                    {answer?.question?.answerType.id ===
                      AnswerTypes.Section && (
                      <>
                        <Base.Text
                          text={answer?.question?.questionText ?? ""}
                          variant="h4"
                        />
                        <Divider />
                      </>
                    )}
                  </Box>
                );
              })}
            {job.description && job.description !== "" && (
              <Grid>
                <Box sx={{ fontWeight: "bold" }} component={"span"}>
                  <Base.Text
                    text="Responder Incident"
                    component="span"
                    variant="h4"
                  />
                </Box>
                {job.description.split("\n").map((t, key) => (
                  <Box key={key}>
                    <Base.Text text={t} />
                  </Box>
                ))}
              </Grid>
            )}
          </Grid>
          {currentViewJobType?.logHours && (
            <Grid size={{ xs: 12 }}>
              <Grid container direction={"column"}>
                <Box sx={{ fontWeight: "bold" }} component={"span"}>
                  <Base.Text text="Hours" component="span" variant="h4" />
                </Box>
                <Base.Text text={`Total Hours: ${jobHours}`} component="span" />
              </Grid>
            </Grid>
          )}
          <JobViewAttachments
            handleDownload={handleDownload}
            title="Attachments"
            attachments={attachments}
          />
        </>
      ) : (
        <Box>
          <Base.Text text="Loading, please wait..." variant="h3" />
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default JobViewTop;
